import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Col, Row, Well } from 'react-bootstrap';
import { Field, Form, FormSection, getFormValues, reduxForm } from 'redux-form';
import Button from '../../../../common/components/Button/Button';

import { compose } from 'redux';
import Icon from '../../../../common/components/Icon/Icon';
import './DefinitionsForm.scss';
import TextArea from '../../../content/components/TextArea';
import isString from '../../../../helpers/socratesLodash/isString';
import ReactMarkdown from 'react-markdown';
import { InfoButton } from '../../../../common/components';
import { get } from 'lodash';
import { InternalButtonBar } from '../../../layout/components';

const DefinitionField = ({ input, definitionMainKey, title, definitions }) => {
  const [disabled, setDisabled] = useState(true);
  const setEditable = () => {
    setDisabled(false);
  };
  // reset to original values and disable
  const handleCancelEditing = () => {
    input.onChange(get(definitions, input.name));
    setDisabled(true);
  };
  const handleFinishEditing = () => {
    setDisabled(true);
  };
  const label = title.replace(/_/g, ' ');

  if (isString(input.value)) {
    if (disabled) {
      return (
        <div>
          <div className={'definition-form--label'}>
            <span onClick={setEditable}>{label}</span>

            <InfoButton content={input.value} />
          </div>
          <div className={'definition-form--content'} onClick={setEditable}>
            <ReactMarkdown source={input.value} />
          </div>
        </div>
      );
    }
    return (
      <>
        <div className={'definition-form--label'}>
          <span>{label}</span>

          <InfoButton content={input.value} />
        </div>
        <Field name={definitionMainKey} component={TextArea} />
        <Row>
          <Col sm={12}>
            <Button bsStyle="default" handleClick={handleCancelEditing}>
              Cancel
            </Button>
            <Button
              bsStyle="primary"
              className="pull-right"
              handleClick={handleFinishEditing}
            >
              Finish Editing
            </Button>
          </Col>
        </Row>
      </>
    );
  }

  return (
    <FormSection name={definitionMainKey}>
      {Object.keys(input.value).map((definitionSubKey) => {
        return (
          <>
            <Field
              name={definitionSubKey}
              title={`${definitionMainKey} - ${definitionSubKey}`}
              definitionMainKey={definitionSubKey}
              component={DefinitionField}
              definitions={definitions}
            />
          </>
        );
      })}
    </FormSection>
  );
};
const DefinitionFields = ({ input, definitions }) => {
  const [showDetails, setShowDetails] = useState(false);
  const toggleShowField = () => {
    setShowDetails(!showDetails);
  };
  return (
    <>
      <Row>
        <Col
          sm={12}
          className={`definition-form--channel ${
            showDetails ? 'red-title' : 'blue-title'
          }`}
        >
          <div onClick={toggleShowField}>
            {input.name}
            <div className="pull-right">
              <Icon name={showDetails ? 'minus-circle' : 'plus-circle'} />
            </div>
          </div>
        </Col>
      </Row>
      {showDetails && (
        <div>
          <FormSection name={input.name}>
            {Object.keys(input.value).map((definitionMainKey) => {
              return (
                <Row className={'definition-form--row'}>
                  <Col sm={12}>
                    <Field
                      name={definitionMainKey}
                      title={definitionMainKey}
                      definitionMainKey={definitionMainKey}
                      component={DefinitionField}
                      definitions={definitions}
                    />
                  </Col>
                </Row>
              );
            })}
          </FormSection>
        </div>
      )}
    </>
  );
};
const DefinitionsForm = ({
  formValues,
  submitting,
  handleSubmit,
  definitions,
  onUpdateDefinitions,
}) => {
  if (!formValues) {
    return null;
  }
  return (
    <Form onSubmit={handleSubmit(onUpdateDefinitions)}>
      <Well>
        <p>Useful variables:</p>
        <div>
          <strong>Channel phone: </strong>
          {'{{channel phone}}'}
        </div>
        <div>
          <strong>Channel name: </strong>
          {'{{channel name}}'}
        </div>
        <div>
          <strong>Virtual Medical Care: </strong>
          {'{{ Virtual Medical Care }}'}
        </div>
      </Well>
      {Object.keys(formValues).map((channelType) => {
        return (
          <Field
            name={channelType}
            definitions={definitions}
            component={DefinitionFields}
          />
        );
      })}
      <div className="divider margin-bottom" />
      <InternalButtonBar
        buttons={[
          {
            button: (
              <Button link={true} bsStyle="default" to={'/admin/products'}>
                Back
              </Button>
            ),
          },
          {
            permissions: ['scheme.edit'],
            button: (
              <Button
                type="submit"
                bsStyle="primary"
                className="pull-right"
                isLoading={submitting}
              >
                Save All Changes
              </Button>
            ),
          },
        ]}
      />
      {/*<Row>*/}
      {/*  <Col sm={12}>*/}
      {/*    <Button link={true} bsStyle="default" to={'/admin/products'}>*/}
      {/*      Back*/}
      {/*    </Button>*/}
      {/*    <Button type="submit" bsStyle="primary" className="pull-right">*/}
      {/*      Save All Changes*/}
      {/*    </Button>*/}
      {/*  </Col>*/}
      {/*</Row>*/}
    </Form>
  );
};

const FORM_NAME = 'DefinitionsForm';

export default compose(
  connect(
    (state, props) => ({
      formValues: getFormValues(FORM_NAME)(state),
      initialValues: props.definitions,
    }),
    null,
  ),
  reduxForm({ form: FORM_NAME }),
)(DefinitionsForm);
